module.exports = __webpack_public_path__ + "img/T2D_rc_6.eefdc751.png";